export default function DisclaimerSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center md:text-left">
          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">About Us</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              Our team researches trusted sellers and updates spreadsheet resources for global buyers. We have 5+ years of experience in cross-border purchasing, helping thousands of international shoppers access the best products from Chinese marketplaces.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">Editorial Policy</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              All product recommendations are independently reviewed by our research team. We do not accept payment for placements. Every seller and product in our spreadsheet is personally verified through multiple transactions.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">Disclaimer</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              This website is an independent resource and is not affiliated with AllChinaBuy. All trademarks belong to their respective owners. Prices and availability are subject to change without notice.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}